import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import LoginForm from "../components/login/login";
import { errorCodeTexts } from "../constants";
import ScreenPagePart from "../components/login/screenpage";

const ErrorPage = (props: { code: number; message?: string; link?: {name: string, action: () => void} }) => {
  return (
    <ScreenPagePart>
      <div className="inner centerItem">
        <div className="errorContentInner">
          <h1>{props.code}</h1>
          <h3>{errorCodeTexts[String(props.code)]}</h3>
          {props.message && <p>{props.message}</p>}
          {<div
        className={`btn loginActionButton`}
        onClick={props.link ? props.link.action : () => document.location.href="/"}
      >
        {props.link ? props.link.name : "На главную"}
      </div>}
        </div>
      </div>
    </ScreenPagePart>
  );
};

export default ErrorPage;
